export default __webpack_public_path__ + "static/media/calendar.0b2ae4da.svg";